import { render, staticRenderFns } from "./PopupBannerForm.vue?vue&type=template&id=06e83ad4&scoped=true"
import script from "./PopupBannerForm.vue?vue&type=script&lang=js"
export * from "./PopupBannerForm.vue?vue&type=script&lang=js"
import style0 from "./PopupBannerForm.vue?vue&type=style&index=0&id=06e83ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e83ad4",
  null
  
)

export default component.exports